import { useTheme } from "@hooks/useTheme";

const OutlineButton = ({
  children,
  onClick,
  className = "",
  disabled = false,
  type = "button",
  size = "md",
  ...props
}) => {
  const { colors } = useTheme();

  const sizeClasses = {
    sm: "h-8 px-4 py-1.5 text-xs",
    md: "h-9 px-5 py-2 text-sm",
    lg: "h-10 px-6 py-3 text-base",
  };

  const baseClasses = `min-w-[86px] w-max inline-flex items-center justify-center rounded-md font-medium transition-colors border ${colors.borderActiveDashed} ${colors.textActive} ${colors.bgButton}`;

  const disabledClasses = disabled ? "opacity-50 cursor-not-allowed" : "hover:opacity-80";

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseClasses} ${sizeClasses[size]} ${disabledClasses} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default OutlineButton;
